<script setup lang="ts">
import type { SectionLocationMapRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionLocationMapRecord
  moduleIndex: number
}>()
const { level, isSemantic } = useSectionRules(props.moduleIndex, !!props.data.title)
</script>

<template>
  <section class="bg-cream pb-4 pt-8 text-yellow lg:py-12">
    <div class="container grid-default">
      <Heading
        v-if="data.title"
        :level="level"
        :is-semantic="isSemantic"
        :size="undefined"
        class="col-span-full !text-lg uppercase lg:col-span-3 lg:!text-xl"
      >
        {{ data.title }}
      </Heading>
      <div class="col-span-full lg:col-span-9">
        <span class="text-lg uppercase lg:text-xl"> Map </span>
        <Image
          v-if="data.media"
          loading="lazy"
          class="mt-4 lg:mt-8"
          :src="data.media.responsiveImage ? data.media.responsiveImage?.src : data.media.url"
          :srcset="data.media.responsiveImage ? data.media.responsiveImage?.webpSrcSet : undefined"
          :width="
            data.media.responsiveImage
              ? data.media.responsiveImage?.width
              : (data.media.width ?? 1280)
          "
          :height="
            data.media?.responsiveImage
              ? data.media.responsiveImage?.height
              : (data.media?.height ?? 720)
          "
          :alt="data.media.alt ?? ''"
          :sizes="data.media.responsiveImage ? data.media.responsiveImage?.sizes : undefined"
        />
        <TableBlock v-if="data.table" :data="data.table" />
      </div>
    </div>
  </section>
</template>
